import { Component, inject } from '@angular/core';
import {LocationService} from "../administration/location/location.service";

@Component({
    selector: 'app-schedule',
    templateUrl: './schedule.component.html',
    styleUrls: ['./schedule.component.scss'],
    standalone: false
})
export class ScheduleComponent {
  locationService = inject(LocationService);
}
